module.exports = __webpack_public_path__ + "static/media/ic_refresh_blue.9e9c1c8a.svg";